import React from "react";

import { IFormUUID } from "../../../models/nominals";
import { IReviewsProduct } from "../../../models/reviews.interfaces";
import { useAppSelector } from "../../reducers";
import { WriteReviewFormMode } from "../constants";
import {
    getWriteReviewFormHTMLID,
    getWriteReviewFormState,
} from "../selectors";
import { MultiProductWriteReviewFormProductHeading } from "./MultiProductWriteReviewFormProductHeading";
import { WriteReviewFormFields } from "./WriteReviewFormFields";

interface IProps {
    formUUID: IFormUUID;
    brand?: string;
    product: IReviewsProduct;
    isMultiReview?: boolean;
    side?: string;
}

export const MultiProductWriteReviewFormSection = (
    props: IProps,
): React.ReactNode => {
    const formState = useAppSelector((state) =>
        getWriteReviewFormState(state.reviews, props),
    );

    if (!props.product.uuid) {
        return null;
    }
    const isOpen = formState.mode === WriteReviewFormMode.FORM_OPEN;
    return (
        <div
            id={getWriteReviewFormHTMLID(props.formUUID)}
            className="write-review-form"
        >
            <MultiProductWriteReviewFormProductHeading
                formUUID={props.formUUID}
                productUUID={props.product.uuid}
                side={props.side}
            />
            {isOpen && (
                <WriteReviewFormFields
                    formUUID={props.formUUID}
                    brand={props.brand}
                    isMultiReview={props.isMultiReview}
                />
            )}
        </div>
    );
};
